import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { path, either, curry } from 'ramda'

export const getGlobalStyles = (theme) => {
  const {
    color: { blackPrimary, whitePrimary, shadow },
  } = theme

  return css`
    .ant-tooltip {
      &.autoWidth {
        max-width: none;
      }

      &.svg-tooltip {
        .ant-tooltip-inner {
          background-color: ${whitePrimary} !important;
          color: ${blackPrimary};
        }
        .ant-tooltip-arrow {
          border-top-color: ${whitePrimary} !important;
          &::before {
            background-color: ${whitePrimary} !important;
            box-shadow: 0 2px 8px ${shadow};
          }
        }
      }

      .ant-tooltip-inner {
        background-color: ${blackPrimary} !important;
        color: ${whitePrimary};
        border-radius: 4px;
        box-shadow: 0 2px 8px ${shadow};
        white-space: pre-wrap;
        width: 100%;
      }

      .ant-tooltip-arrow {
        border-top-color: ${blackPrimary} !important;
      }

      .anticon svg {
        font-size: 12px;
      }

      &.long-message-tooltip {
        max-width: 400px;
        white-space: pre-line;
      }
    }

    .ant-select-dropdown {
      min-width: 80px !important;
    }

    .ant-table-placeholder {
      z-index: 0 !important;
    }

    .ant-dropdown-menu-item {
      padding: 0;
    }

    .app-main:has(.pan-zoom-toolbar) + .app-footer {
      display: none;
    }

    .feature-edit-cancel-tooltip {
      .ant-tooltip-inner {
        background-color: ${whitePrimary} !important;
        color: ${blackPrimary};
      }
      .ant-tooltip-arrow {
        border-top-color: ${whitePrimary} !important;
        &::before {
          background-color: ${whitePrimary};
        }
      }
    }
  `
}

export const stylesIf = curry((condition, styles, stylesElse = '') =>
  condition ? styles : stylesElse
)

export const themeColor = curry((colorName, props) => {
  if (!props) {
    throw new Error(
      `make sure props is second argument if not in interpolation string`
    )
  }

  const color = either(
    path(['theme', colorName]),
    path(['theme', 'color', colorName])
  )(props)

  if (!color) {
    throw new Error(`
      theme color '${colorName}' not found,
      make sure it is defined in theme/index.js
    `)
  }

  return color
})

// Wraps a component in a way that alows us to define the styles in an external
// file without requiring an additional wrapping HTML element.
export const wrap = (getStylesFromProps) => (Component) =>
  styled(Component)(getStylesFromProps)

// For use when we have a container + view component in the same dir.
// This resolves the "TypeError: Converting circular structure to JSON" error
// that we see when we attempt to use the simpler (above) approach to wrapping
// components that are redux-connected to a container.
export const wrapContained = (getStylesFromProps) => (Component) => {
  const StyledComponent = styled(Component)(getStylesFromProps)
  if (Component.name)
    StyledComponent.displayName = `StyledComponent(${Component.name})`
  return (props) => <StyledComponent {...props} />
}

export const changeOpacity = (color, opacity) =>
  color.replace(/[\d.]+\)$/g, `${opacity})`)
